import React, { Fragment, Component } from 'react';
import PropTypes from 'prop-types';
import Config from 'config';
let config;
import classnames from 'classnames';
import metrics from 'lib/common/metrics';
import summaryTitle from 'lib/seats/summaryTitle';
import messagesForSeat from 'lib/seats/messagesForSeat';
import { find, get, has } from 'lodash';

import Modal from './Modal';
import SeatView from './SeatView';
import PriceTypeExisting from './PriceTypeExisting';
import PriceTypeOption from './PriceTypeOption';
import InlineSeatUpsell from './InlineSeatUpsell';
import messageFromWebContents from 'lib/seats/messageFromWebContents';
import { MODES } from 'constants';

class SeatDetails extends Component {
  constructor(props) {
    super(props);
    config = new Config().getConfig();

    this.handleClose = this.handleClose.bind(this);
    this.handleRemoval = this.handleRemoval.bind(this);
    this.hasUpsell = this.hasUpsell.bind(this);
    this.renderSeatUpsell = this.renderSeatUpsell.bind(this);
    this.renderAvailablePrices = this.renderAvailablePrices.bind(this);
    this.renderAdditionalAvailablePrices = this.renderAdditionalAvailablePrices.bind(this);

    this.convertText = this.convertText.bind(this);
  }

  handleClose() {
    const shouldDeselectOnClose = this.props.currentLineItem ? false : true;
    this.props.handleDeselection(
      this.props.selectedSeat,
      shouldDeselectOnClose
    );
  }

  handleRemoval() {
    this.props.handleRemoval(this.props.currentLineItem);
    this.handleClose();
  }

  hasUpsell() {
    return !!this.props.upsell && !this.props.currentLineItem;
  }

  convertText(text) {
    return {
      __html: text
    };
  }

  renderSeatUpsell() {
    if (this.hasUpsell()) {
      // Log Google Analytics custom event saying upsell was shown
      metrics.action(
        'Seat Upsell: Shown Upsell',
        [
          'Upsell shown from',
          this.props.upsell.referencePriceType.description,
          'to',
          this.props.upsell.seat.seatData.section_desc,
          'for performance',
          this.props.upsell.performanceId
        ].join(' ')
      );

      return (
        <div className="syos-selection__upsell">
          <InlineSeatUpsell
            upsell={this.props.upsell}
            handleSelection={this.props.onSelectUpsell}
          />
        </div>
      );
    }

    return null;
  }

  renderAvailablePrices() {
    const { priceTypes, priceTypeOptions, lineItems } = this.props;

    if (!priceTypes || !priceTypes.length) {
      return <p>There are currently no prices available for this seat.</p>;
    }

    const limitReached = {};

    const primaryPriceTypes = get(priceTypeOptions, 'primaryPriceTypes', null);

    priceTypes.forEach(priceType => {
      const priceTypeId = parseInt(priceType.price_type, 10);

      limitReached[priceTypeId] = false;

      if (primaryPriceTypes && priceTypeId in primaryPriceTypes) {
        const priceTypeLineItems = lineItems.filter(lineItem => {
          return parseInt(priceTypeId, 10) === parseInt(lineItem.priceData.price_type, 10);
        });

        limitReached[priceTypeId] = parseInt(primaryPriceTypes[priceTypeId].maxSeats, 10) === priceTypeLineItems.length;
      }
    });

    return (
      <ul className="u-syos-unstyled-list">
        {priceTypes.map((priceType, idx) => {
          return (
            <li key={idx}>
              <PriceTypeOption
                priceType={priceType}
                disabled={limitReached[priceType.price_type]}
                handleSelection={() => {
                  this.props.handleSelection(
                    this.props.selectedSeat,
                    priceType
                  );
                }}
              />
            </li>
          );
        })}
      </ul>
    );
  }

  renderAdditionalAvailablePrices() {
    const { additionalPriceTypes, priceTypeOptions, lineItems } = this.props;

    const limitReached = {};

    const addOnPriceTypes = get(priceTypeOptions, 'addOnPriceTypes', null);

    additionalPriceTypes.forEach(priceType => {
      const priceTypeId = parseInt(priceType.price_type, 10);

      limitReached[priceTypeId] = false;

      if (addOnPriceTypes && priceTypeId in addOnPriceTypes) {
        const priceTypeLineItems = lineItems.filter(lineItem => {
          return parseInt(priceTypeId, 10) === parseInt(lineItem.priceData.price_type, 10);
        });

        limitReached[priceTypeId] = parseInt(addOnPriceTypes[priceTypeId].maxSeats, 10) === priceTypeLineItems.length;
      }
    });

    return (
      <ul className="u-syos-unstyled-list">
        {additionalPriceTypes.map((priceType, idx) => {
          return (
            <li key={idx}>
              <PriceTypeOption
                priceType={priceType}
                disabled={limitReached[priceType.price_type]}
                handleSelection={() => {
                  this.props.handleSelection(
                    this.props.selectedSeat,
                    priceType
                  );
                }}
              />
            </li>
          );
        })}
      </ul>
    );
  }

  render() {
    const { mode, selectedSeat, performanceDetails, priceTypes, seatView, currentLineItem, additionalPriceTypes, currentFacility } = this.props;

    const messages = messagesForSeat(config.seatMessages, selectedSeat.seatData);

    const webContentMessage = messageFromWebContents(selectedSeat.seatData, performanceDetails.WebContent, priceTypes);

    let facility = null
    let disableRowTitle = false;

    if (currentFacility) {
      facility = find(config.facilityMapping, facility => {
        return parseInt(facility.facility_no, 10) === parseInt(currentFacility.facility_no, 10);
      });

      if (facility && has(facility, 'disableRowTitle')) {
        disableRowTitle = facility.disableRowTitle.includes(selectedSeat.seatData.short_desc);
      }
    }

    return (
      <Modal onClose={this.handleClose}>
        <div
          className={classnames({
            'syos-selection': true,
            'has-upsell': this.hasUpsell()
          })}
        >
          <div className="syos-selection__details">
            <div className="syos-seat-details">
              <h4 className="syos-seat-details__title">
                {summaryTitle(selectedSeat.seatData, null, disableRowTitle)}
              </h4>
              {seatView && seatView.image && (
                <div className="syos-seat-details__seatview">
                  <SeatView seatView={seatView} />
                </div>
              )}
              {messages.length > 0 && (
                <div className="syos-seat-details__messages">
                  {messages.map((message, key) => {
                    return <p key={key}>{message.text}</p>;
                  })}
                </div>
              )}
              {webContentMessage && (
                <div
                  className="syos-seat-details__messages"
                  dangerouslySetInnerHTML={this.convertText(webContentMessage)}
                />
              )}
              {currentLineItem ? (
                <div className="syos-seat-details__pricetypes">
                  <PriceTypeExisting
                    handleRemoval={this.handleRemoval}
                    description={config.basket.existingMessage}
                  />
                </div>
              ) : (
                <div className="syos-seat-details__pricetypes">
                  {mode === MODES.FLEX_PACKAGE_PERFORMANCE ? (
                    <h5 className="syos-seat-details__subtitle">
                      Package Tickets
                    </h5>
                  ) : null}

                  {this.renderAvailablePrices()}
                </div>
              )}
              {!currentLineItem && additionalPriceTypes.length ? (
                <div>
                  <h5 className="syos-seat-details__subtitle">
                    Extra Single Tickets
                  </h5>

                  <div className="syos-seat-details__pricetypes">
                    {this.renderAdditionalAvailablePrices()}
                  </div>
                </div>
              ) : null}
            </div>
          </div>
          {this.renderSeatUpsell()}
        </div>
      </Modal>
    );
  }
}

SeatDetails.propTypes = {
  mode: PropTypes.string,
  selectedSeat: PropTypes.object.isRequired,
  seatView: PropTypes.object,
  priceTypes: PropTypes.arrayOf(PropTypes.object).isRequired,
  additionalPriceTypes: PropTypes.arrayOf(PropTypes.object),
  currentLineItem: PropTypes.object,
  handleSelection: PropTypes.func.isRequired,
  handleDeselection: PropTypes.func.isRequired,
  handleRemoval: PropTypes.func.isRequired,
  upsell: PropTypes.object,
  onSelectUpsell: PropTypes.func,
  performanceDetails: PropTypes.object,
  priceTypeOptions: PropTypes.object,
  lineItems: PropTypes.array,
};

export default SeatDetails;



// WEBPACK FOOTER //
// ./src/javascripts/components/SeatDetails.js